export { default as name } from './name';
export { default as contactPoints } from './contact-points';
export { default as openingHours } from './opening-hours';
export { default as location } from './location';
export { default as areaServed } from './area-served';
// export { default as customProperties } from './custom-properties';
